import { normalizeText } from '@/utils/normalizeText';

interface AgentSearchableFields {
  name?: string | null;
  username?: string | null;
}

export const agentSearchTermMatchMapper = (agent: AgentSearchableFields, rawSearchTerm: string) => {
  const searchTerm = normalizeText(rawSearchTerm).trim().toLowerCase();
  if (!searchTerm) return false;

  const name = normalizeText(agent.name ?? '').toLowerCase();
  const username = normalizeText(agent.username ?? '').toLowerCase();

  return name.includes(searchTerm) || username.includes(searchTerm);
};

export const channelHasAgentMatchingSearchTerm = (
  channel: { agents: AgentSearchableFields[] },
  rawSearchTerm: string,
) => channel.agents.some((agent) => agentSearchTermMatchMapper(agent, rawSearchTerm));
